import { z } from "zod";

/**
 * Étape optionnelle (le paiement n'est pas toujours soldé par chèque) :
 * aucune règle de complétude, mais si un montant est saisi il doit être > 0.
 */
export const pvReceptionChequeSchema = z
  .object({ montantSolde: z.number().positive() })
  .partial();

export type PvReceptionCheque = z.infer<typeof pvReceptionChequeSchema>;
